
import { Button } from '@mui/material'
import { DownloadCloud, Trash2 } from 'react-feather'
import { TooltipInformation, CustomTableData, LinearLoading } from '../../../../common'

export const QuotationTable = ({useFetchInit}) => {

  const {
    FetchData,
    Actions,
  }= useFetchInit

  const { fetchAllQuotations } = FetchData
  const { quotes, loadinFetchQuotations,  } = fetchAllQuotations

  const { handleButtonDisable, generatePDF} = Actions
  
  const columnConfig = [
    {
      headerName: 'info',
      maxWidth: 80,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      cellRenderer: (params) => {

        const {
          idcotizacion,
          usuario_creo,
          fecha_creo,
          usuario_modifico,
          fecha_modifico
        } = params.data;
        
        return <TooltipInformation
          idregistro={idcotizacion}
          usuario_creo={usuario_creo}
          fecha_creo={fecha_creo}
          usuario_modifico={usuario_modifico}
          fecha_modifico={fecha_modifico}
        />
      },
    },
    { field: 'nombre_cliente', headerName: 'CLIENTE', minWidth: 230, filter: true },
    { field: 'tipo_cuota', headerName: 'TIPO CUOTA', minWidth: 150, filter: true }, 
    { field: 'fecha', headerName: 'FECHA', minWidth: 150, filter: true }, 
    { field: 'numero_cotizacion', headerName: 'IDENTIFICADOR', minWidth: 170, filter: true },
    { field: 'monto_venta', headerName: 'MONTO TOTAL', minWidth: 150, filter: true },
    { field: 'monto_enganche', headerName: 'FINANCIAMIENTO', minWidth: 170, filter: true },
    { field: 'interes', headerName: 'INTERES', minWidth: 100, filter: true },
    {
      headerName: "OPCIONES",
      minWidth: 440,
      cellRenderer: (params) => {

      const {idcotizacion} = params.data

      return(
          <>
              <Button 
                  startIcon = { <DownloadCloud/>}
                  variant='contained'
                  size='small' 
                  color='success'
                  sx={{ marginRight: '8px' }}
                  onClick={() => generatePDF(idcotizacion)} 
                  style={ { width: 150 } }
                  > 
                  Descargar
              </Button>
              <Button
                  startIcon = { <Trash2/> }
                  variant='contained'
                  size='small' 
                  color='error'
                  onClick={() => handleButtonDisable(idcotizacion)} 
                  style={ { width: 150 } }
                  > 
                  Eliminar
              </Button>
          </>
      )
      },
    },
  ];
  return (
    <>
      {(loadinFetchQuotations)&&(<LinearLoading/>)}
      <CustomTableData
        rowConfig={quotes}
        columnConfig={columnConfig}
      />
    </>
  );
};
